import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_ALERTS = createActionTypes('FETCH_ALERTS');

